import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#1a1c1b] text-[#dfddd6]">
      <Header />
      <main className="max-w-2xl mx-auto px-5 md:px-10 py-24 md:py-32">
        <div className="bg-[#302f2c] border border-[#3f4816] rounded-2xl p-8 md:p-12 text-center">
          <XCircle className="mx-auto text-[#888680] mb-6" size={64} data-testid="payment-cancel-icon" />
          <h1 className="text-3xl md:text-4xl font-black text-[#d9fb06] uppercase mb-4" data-testid="payment-cancel-title">
            Paiement annulé
          </h1>
          <p className="text-[#dfddd6] mb-2">Aucun montant n'a été prélevé.</p>
          <p className="text-[#888680] mb-8 text-sm">
            Vous pouvez reprendre votre commande à tout moment.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/">
              <Button
                data-testid="payment-cancel-home-btn"
                className="bg-[#d9fb06] text-[#1a1c1b] hover:bg-[#d9fb06]/90 rounded-full px-8 py-3 text-sm font-bold uppercase"
              >
                Retour à l'accueil
              </Button>
            </Link>
            <Link to="/#pricing">
              <Button
                data-testid="payment-cancel-retry-btn"
                variant="outline"
                className="rounded-full px-8 py-3 text-sm font-bold uppercase border-[#d9fb06] text-[#d9fb06] hover:bg-[#d9fb06] hover:text-[#1a1c1b]"
              >
                Voir les tarifs
              </Button>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
